<template>
  <div>
    <el-dialog
      :center="true"
      :visible.sync="show"
      :close-on-click-modal="false"
      :modal="true"
      top="5vh"
      width="auto"
      height="auto"
      :append-to-body="true"
      class="dialog"
    >
      <div class="box">
        <div class="b_head">
          <span>{{ lang.viewDetails }}</span>
          <svg
            @click="close()"
            t="1748587270371"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5023"
            width="200"
            height="200"
          >
            <path
              d="M0 0h1024v1024H0z"
              fill="#FF0033"
              fill-opacity="0"
              p-id="5024"
            ></path>
            <path
              d="M240.448 168l2.346667 2.154667 289.92 289.941333 279.253333-279.253333a42.666667 42.666667 0 0 1 62.506667 58.026666l-2.133334 2.346667-279.296 279.210667 279.274667 279.253333a42.666667 42.666667 0 0 1-58.005333 62.528l-2.346667-2.176-279.253333-279.253333-289.92 289.962666a42.666667 42.666667 0 0 1-62.506667-58.005333l2.154667-2.346667 289.941333-289.962666-289.92-289.92a42.666667 42.666667 0 0 1 57.984-62.506667z"
              fill="#111111"
              p-id="5025"
            ></path>
          </svg>
        </div>
        <div class="b_main" v-loading="loading">
          <div class="sc_tableArea">
            <div class="sc_ta_header">
              <div class="sc_ta_h_item">
                <span>{{ lang.student_name }}</span>
                <span>{{ lang.typicalPerformance }}</span>
                <span style="width: 300px">{{ lang.node }}</span>
                <span>{{ lang.specificSuggestions }}</span>
              </div>
            </div>
            <div class="sc_ta_box">
              <div
                class="sc_ta_b_item"
                v-for="(item, index) in studentList"
                :key="item.id + '_' + index"
              >
                <div>
                  <div>
                    <div>{{ item.name }}</div>
                  </div>
                  <div>
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.performance"
                      placement="top"
                    >
                      <span class="summaryText">
                        {{ item.performance ? item.performance : "-" }}
                      </span>
                    </el-tooltip>
                  </div>
                  <div style="width: 300px">
                    <div
                      class="nodeArea"
                      v-if="item.nodeData && item.nodeData.length > 0"
                    >
                      <el-popover
                        v-for="(na, index) in item.nodeData"
                        :key="na.nodeId"
                        placement="right"
                        trigger="hover"
                        popper-class="nodePopover"
                      >
                        <div class="na_message">
                          <template v-for="(m, mIndex) in na.messageList">
                            <div :key="m.uid + '_' + mIndex">
                              <div v-if="m.userContent" class="na_m_item">
                                <div class="na_m_i_name">
                                  {{ m.userName }}
                                </div>
                                <div
                                  class="na_m_i_content"
                                  v-html="m.userContent"
                                ></div>
                              </div>

                              <div class="na_m_item" v-if="m.aiContent">
                                <div class="na_m_i_name aiName">
                                  {{ m.aiName }}
                                </div>
                                <div
                                  class="na_m_i_content"
                                  v-html="m.aiContent"
                                ></div>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div
                          class="na_item"
                          slot="reference"
                          :class="{ nodeBar: item.nodeData.length - 1 > index }"
                        >
                          <span>{{
                            index + 1 < 10 ? "0" + (index + 1) : index + 1
                          }}</span>
                          <img
                            v-if="na.status == '0'"
                            src="@/assets/img/teachingMode/good.svg"
                          />
                          <img
                            v-else-if="na.status == '1'"
                            src="@/assets/img/teachingMode/bad.svg"
                          />
                          <img
                            v-else-if="na.status == '2'"
                            src="@/assets/img/teachingMode/default.svg"
                          />
                        </div>
                      </el-popover>
                    </div>
                    <span v-else>-</span>
                  </div>
                  <div>
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="item.suggestion"
                      placement="top"
                    >
                      <span class="summaryText">
                        {{ item.suggestion ? item.suggestion : "-" }}
                      </span>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="b_bottom">
          <el-button size="small" type="primary" @click="close()">{{
            lang.queding
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      show: false,
      studentList: [],
      data: null,
    };
  },
  computed: {},
  methods: {
    async open(data) {
      this.data = JSON.parse(JSON.stringify(data));
      this.show = true;
      this.loading = true;
      if (this.data.length > 0) {
        let _studentList = await this.getStudentWorkData(
          this.data.map((i) => i.id).join(",")
        );

        _studentList.forEach((i) => {
          let _indexData = this.data.find(i2=>i2.id==i.id);
          if(_indexData){
            i.performance = _indexData.performance
            i.suggestion = _indexData.suggestion
          }
        })

        this.studentList = _studentList;
        this.loading = false;
      }
    },
    close() {
      this.show = false;
      this.init();
    },
    init() {
      this.data = null;
      this.loading = false;
      this.studentList = [];
    },
    getStudentWorkData(sid) {
      return new Promise((resolve) => {
        if (!this.tid) return resolve([]);
        let params = {
          uid: this.user.userId,
          tid: this.tid,
          sid: sid,
        };

        this.ajax
          .get(this.$store.state.api + "select_teachingModeWorks", params)
          .then((res) => {
            let _result = res.data[0];
            if (_result.length > 0) {
              _result.forEach((i) => {
                //i.summary = i.summary ? JSON.parse(i.summary) : "";
                i.nodeData = i.nodeData ? JSON.parse(i.nodeData) : [];
              });

              resolve(_result);
            } else {
              resolve([]);
            }
          })
          .catch((err) => {
            console.log(err);
            resolve([]);
          });
      });
    },
  },
};
</script>

<style scoped>
.dialog >>> .el-dialog {
  width: 80vw !important;
  border-radius: 8px;
  padding: 0;
  background-color: #fff;
  overflow: hidden;
}

.dialog >>> .el-dialog__body {
  width: 80vw !important;
  height: auto;
  flex-shrink: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}

.dialog >>> .el-dialog__header {
  display: none !important;
}

.box {
  width: 80vw;
  height: auto;
  background: #fafafa;
  border-radius: 15px;
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
    0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
}

.b_head {
  width: 100%;
  height: 50px;
  border-radius: 15px 15px 0 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
}

.b_head > span {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.b_head > img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.b_head > svg {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.b_main {
  width: 100%;
  height: 80vh;
  background: #fafafa;
  padding: 0px 20px 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.b_bottom {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 20px;
}

.id_b_QrCode {
  width: 300px;
  height: 300px;
  margin: 40px 0;
  background-color: #000;
}

.url_box {
  width: 100%;

  margin-bottom: 20px;
}

.sc_tableArea {
  width: 100%;
  min-height: calc(100% - 50px - 30px);
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
}

.sc_ta_header {
  width: 100%;
  height: 56px;
  border-radius: 12px 12px 0 0;
  background-color: #fff;
  box-sizing: border-box;
  border-bottom: solid 1px #bdbdbd;
  padding: 0 50px;
}

.sc_ta_h_item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sc_ta_h_item > span {
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #00000099;
  text-align: center;
}
.sc_ta_h_item > span:nth-child(1) {
  justify-content: flex-start;
  color: #000;
}
/* .sc_ta_h_item > span:nth-last-of-type(1) {
  justify-content: flex-end;
  flex: 0.5;
} */

.sc_ta_box {
  width: 100%;
  height: calc(100% - 56px);
  background-color: #fcfbfb;
  border-radius: 0 0 12px 12px;
  box-sizing: border-box;
  overflow: auto;
  box-sizing: border-box;
}

.sc_ta_b_item {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #e7e7e7;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 30px;
  transition: 0.2s;
}
.sc_ta_b_item:hover {
  background-color: #fff;
}

.sc_ta_b_item > div {
  width: 100%;
  position: relative;
  height: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  padding: 0 20px;
  transition: 0.1s;
}

.sc_ta_b_item > div > div {
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  position: relative;
  color: #000;
}

.sc_ta_b_item > div > div:nth-child(1) {
  justify-content: flex-start;
  font-weight: bold;
}

.sc_ta_b_item > div > div:nth-last-of-type(1) > svg {
  width: 30px;
  height: 30px;
  cursor: pointer;
  transition: 0.3s;
}
.sc_ta_b_item > div > div:nth-last-of-type(1) > svg:hover {
  fill: #3681fc !important;
}

.collaboration {
  padding: 2px 10px;
  background-color: none;
  margin-left: 10px;
  border: dashed 1px #000;
  border-radius: 20px;
  font-size: 14px;
  cursor: default;
}
.taskStatus {
  padding: 4px 20px;
  border-radius: 20px;
  font-size: 14px;
  border: solid 1px #fff;
}
.taskStatus_1 {
  background-color: #effcf5;
  color: #17c469;
  border-color: #d1f6a0;
}
.taskStatus_0,
.taskStatus_2,
.taskStatus_3 {
  background-color: #f3f3f3;
  color: rgba(0, 0, 0, 0.4);
  border-color: #d5deeb;
}
.status {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  position: absolute;
  top: 8px;
  left: -6px;
}
.status_0 {
  background-color: #d9d9d9;
}
.status_1 {
  background-color: #bce685;
}
.status_2 {
  background-color: #f06643;
}
.nodeStage {
  width: 100%;
  height: 10px;
  position: absolute;
  left: 0;
  bottom: 10px;
  display: flex;
}

.nodeStage > span {
  width: 8px;
  height: 8px;
  border-radius: 10px;
  background-color: #d9d9d9;
  box-sizing: border-box;
  border: dashed 1px #000;
  margin-right: 3px;
}

.ns_active {
  background-color: #3681fc;
  border-color: #3681fc;
}

.summaryText {
  display: -webkit-box;
  width: 100%;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  text-align: center;
}
.nodeArea {
  width: auto;
  height: auto;
  overflow: hidden;
  display: flex;
}

.nodeArea:hover {
  overflow: auto;
}

.na_item {
  width: 30px;
  min-width: 30px;
  height: 60px;
  display: inline-flex;
  margin: auto 10px;
  border-radius: 20px;
  box-sizing: border-box;
  border: dashed 1px #969ba3;
  position: relative;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  color: #969ba3;
}
.nodeBar::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -16px;
  width: 10px;
  height: 2px;
  border-radius: 10%;
  background-color: #969ba3;
}

.na_message {
  width: 500px;
  max-height: 70vh;
  padding-right: 10px;
  overflow: auto;
}

.na_m_item {
  width: 100%;
  height: auto;
  margin: 10px 0;
}

.na_m_i_name {
  width: fit-content;
  max-width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 5px 10px;
  border-radius: 10px 10px 0 0;
  background-color: #9747ff;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.aiName {
  background-color: #0560fc;
}
.na_m_i_content {
  padding: 10px;
  border: solid 1px #e7e7e7;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
  border-radius: 0 0 12px 12px;
}
</style>
